import React from "react";

export default function RideCard({ item }: any) {
  const containerStyle = {
    backgroundColor: "#FFFFFF",
    padding: 15,
    borderRadius: 10,
    boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.2)",
    marginBottom: 20,
    border: `1px solid #000`,
    width: "100%",
    maxWidth: "30.5rem",
  };

  const dateStr = new Date(item?.created_at).toLocaleDateString("en-IN");
  const timeStr = new Date(item?.created_at).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div style={containerStyle}>
      {/* Fare and Time */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 8,
        }}
      >
        <div style={{ fontSize: 16 }}>₹{item?.fare}</div>
        <div style={{ fontSize: 10, color: "#848484" }}>
          {dateStr} | {timeStr}
        </div>
      </div>

      {/* Status */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 6,
        }}
      >
        <div style={{ fontSize: 10, color: "#848484" }}>Status</div>
        <div
          style={{
            fontSize: 12,
            color:
              item?.status === "finished"
                ? "green"
                : item?.status === "onprogress"
                  ? "blue"
                  : item?.status === "canceled"
                    ? "red"
                    : "#848484",
          }}
        >
          {item?.status === "finished"
            ? "COMPLETED"
            : item?.status.toUpperCase()}
        </div>
      </div>

      {/* Pickup & Drop */}
      <div style={{ marginTop: 10 }}>
        <div style={{ fontSize: 10, lineHeight: "10px", color: "#848484" }}>
          Pickup
        </div>
        <div style={{ display: "flex" }}>
          <div
            style={{
              fontSize: 12,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {item?.origin.place_name}
          </div>
        </div>

        <div
          style={{
            fontSize: 10,
            lineHeight: "10px",
            marginTop: 15,
            color: "#848484",
          }}
        >
          Drop
        </div>
        <div style={{ display: "flex" }}>
          <div
            style={{
              fontSize: 12,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {item?.destination.place_name}
          </div>
        </div>

        <div>
          <div
            style={{
              fontSize: 10,
              lineHeight: "10px",
              marginTop: 15,
              marginBottom: 8,
              color: "#848484",
            }}
          >
            Ride Details
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                fontSize: 12,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: "red",
              }}
            >
              Canceled by : {item?.canceled_by || "--"}
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                fontSize: 12,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: "red",
              }}
            >
              Canceled reason : {item?.cancel_reason || "--"}
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                fontSize: 12,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              Connected rider name : {item?.rider?.name}
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                fontSize: 12,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              Connected rider mobile : {item?.rider?.mobile}
            </div>
          </div>
          {item?.driver && (
            <>
              <hr style={{ borderTop: `1px solid #000` }} />
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    fontSize: 12,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Connected captain name : {item?.driver?.name}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    fontSize: 12,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Connected captain mobile : {item?.driver?.mobile}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
